
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { LOGO } from './../util/constants'

// Map
import GoogleMapReact from 'google-map-react';

// Mui
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

// Custom
import { darkStyle, lightStyle } from './mapStyles'

const GOOGLE_MAPS_API_KEY = 'AIzaSyDI7FnwrRu676vvuWE4pLWSt3wwtNItOzM'

const initialCenter = {
    lat: 39.0,
    lng: 35.5,
}

function StaticMap(props) {

    // Props
    const { t } = useTranslation()
    const form = useSelector(state => state.form)

    // Theme
    const theme = useTheme();

    // Map center and zoom
    const [center, setCenter] = useState(initialCenter);
    const [zoom, setZoom] = useState(10);

    // Maps
    const [map, setMap] = useState();
    const [maps, setMaps] = useState();
    const [bounds, setBounds] = useState();

    // On dealer list change
    useEffect(() => {

        if (map && maps && form.dealer) {

            // New bound
            const bounds = new maps.LatLngBounds();
            const icon = {
                url: LOGO.MARKER,
                scaledSize: new maps.Size(45, 45),
            };
            const marker = new maps.Marker({
                position: { lat: form.dealer.latitude, lng: form.dealer.longitude },
                icon: icon,
                map: map,
            })

            marker.setCursor('default');

            bounds.extend(new maps.LatLng(form.dealer.latitude, form.dealer.longitude));

            setBounds(bounds)
        }

    }, [map, maps, theme.palette.mode]);

    // On bounds change
    useEffect(() => {
        if (map && maps && bounds) {

            // New bound
            const extendSize = 0.005
            bounds.extend(new maps.LatLng(bounds.getNorthEast().lat() + extendSize, bounds.getNorthEast().lng() + extendSize));
            bounds.extend(new maps.LatLng(bounds.getNorthEast().lat() - extendSize, bounds.getNorthEast().lng() - extendSize));
            bounds.extend(new maps.LatLng(bounds.getSouthWest().lat() + extendSize, bounds.getSouthWest().lng() + extendSize));
            bounds.extend(new maps.LatLng(bounds.getSouthWest().lat() - extendSize, bounds.getSouthWest().lng() - extendSize));
            map.fitBounds(bounds)
        }
    }, [bounds])


    function onApiLoaded({ map, maps }) {
        setMap(map)
        setMaps(maps)
    }

    return (
        <Box width={1} height={1} boxShadow={4} bgcolor="background.paper" flex='1 0 0'>
            <GoogleMapReact
                bootstrapURLKeys={{
                    key: GOOGLE_MAPS_API_KEY,
                }}
                options={{
                    styles: theme.palette.mode === 'dark' ? darkStyle : lightStyle,
                    backgroundColor: theme.palette.mode === 'dark' ? 'black' : undefined,
                    disableDefaultUI: true,
                    draggable: false,
                    zoomControl: false,
                    draggableCursor: 'default',
                    draggingCursor: 'default',
                }}
                center={center}
                zoom={zoom}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={onApiLoaded}
            >
            </GoogleMapReact>
        </Box>
    )
}

export default StaticMap